// extracted by mini-css-extract-plugin
export default {"waiting":"status_waiting__Yv2US","completed":"status_completed__drVib","deleted":"status_deleted__RNZtu","placeHolderShimmer":"status_placeHolderShimmer__Kq79U"};